import React, { useEffect, useRef, useState } from "react";
import imageService from "../../services/image";
import { useMutation } from "@apollo/client";
import { DELETE_IMAGE } from "../../gql/misc";
import { BLOG, UPDATE_BLOG } from "../../gql/blog";
import RichTextEditor from "react-rte";

import {
  Box,
  FormControl,
  TextField,
  Typography,
  CardMedia,
  InputLabel,
  FormHelperText,
  Button,
  CircularProgress,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { UPDATE_MUSCLE_TYPE } from "../../gql/muscleTypes";

const fileTypes = [
  "image/apng",
  "image/bmp",
  "image/gif",
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/svg+xml",
  "image/tiff",
  "image/webp",
  "image/x-icon",
];

const toolbarConfig = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: [
    "INLINE_STYLE_BUTTONS",
    "BLOCK_TYPE_BUTTONS",
    "LINK_BUTTONS",
    "BLOCK_TYPE_DROPDOWN",
    "HISTORY_BUTTONS",
  ],
  INLINE_STYLE_BUTTONS: [
    { label: "Bold", style: "BOLD", className: "custom-css-class" },
    { label: "Italic", style: "ITALIC" },
    { label: "Underline", style: "UNDERLINE" },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: "Normal", style: "unstyled" },
    { label: "Heading Large", style: "header-one" },
    { label: "Heading Medium", style: "header-two" },
    { label: "Heading Small", style: "header-three" },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" },
  ],
};

const UpdateMuscleType = (props) => {
  console.log("props ", props.muscleType);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [isImageChange, setIsImageChange] = useState(false);
  const [oldImageName, setOldImageName] = useState(null);

  const fileInputRef = useRef(null);
  useEffect(() => {
    let blog = props?.muscleType;
    setValues(blog);
    console.log("image prew ", blog?.image_url);
    setImagePreview(blog?.image_url);
    let image_url = blog?.image_url;
    setOldImageName(
      image_url?.substring(image_url?.lastIndexOf("/") + 1, image_url?.lenght)
    );
  }, [props?.muscleType]);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const [updateBlog] = useMutation(UPDATE_MUSCLE_TYPE, {
    onError: (error) => {
      console.log("error : ", error);
    },
    onCompleted: () => {
      setValues({});
      setErrors({});

      setImageFile("");
      setImagePreview("");
      setLoading(false);
      // props.blogAlert("Blog have been updated.", false);
      // props.handleClose();
      alert("Muscle Type has been Updated");
    },
  });

  const [deleteImage] = useMutation(DELETE_IMAGE, {
    onError: (error) => {
      console.log("error : ", error);
      setLoading(false);
    },
  });

  const imageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      if (!fileTypes.includes(img.type)) {
        setErrors({
          ...errors,
          image_url: "Please select image. (PNG, JPG, JPEG, GIF, ...)",
        });
        return;
      }
      if (img.size > 10485760) {
        setErrors({
          ...errors,
          image_url: "Image file size must be smaller than 10MB.",
        });
        return;
      }
      setImageFile(img);
      setImagePreview(URL.createObjectURL(img));
      setImageUploading(true);
      setErrors({ ...errors, image_url: "" });
      try {
        const result = await imageService.uploadFile(img);
        setValues((prev) => ({ ...prev, image_url: result.imageUploadUrl }));
        setIsImageChange(true);
      } catch (err) {
        setErrors({ ...errors, image_url: err?.message || "Upload failed." });
      } finally {
        setImageUploading(false);
      }
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setErrors({});
    let isErrorExit = false;
    let errorObject = {};
    if (!values.name) {
      errorObject.name = "Name field is required.";
      isErrorExit = true;
    }

    if (isErrorExit) {
      setErrors({ ...errorObject });
      setLoading(false);
      return;
    }
    try {
      if (isImageChange && oldImageName) {
        deleteImage({ variables: { image_name: oldImageName } });
      }
      await updateBlog({ variables: { ...values, id: props?.muscleType.id } });
      navigate(-1);
    } catch (error) {
      console.log("error : ", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          color: "black",
          bgcolor: "#cecece",
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,
          py: 2,
        }}
      >
        <Typography variant="h5" component="h2" color="black" sx={{ mx: 4 }}>
          Update MuscleType
        </Typography>
        <Button
          onClick={() => navigate(-1)}
          variant="contained"
          color="error"
          sx={{ mx: 4 }}
        >
          Close
        </Button>
      </Box>

      <Card sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
        <CardContent className="grid--2--cols">
          {/* image */}

          {imagePreview ? (
            <Box className="grid-img">
              <CardMedia
                sx={{
                  flex: 1,
                  bgcolor: "#cecece",
                  objectFit: "contain",
                  mt: 4,
                  boxShadow: 5,
                  borderRadius: 2,
                }}
                component="img"
                height="300"
                image={imagePreview}
                alt="exercise image"
                className="grid_img"
              />
            </Box>
          ) : (
            <Box className="grid-img">
              <CardMedia
                sx={{
                  flex: 1,
                  bgcolor: "#cecece",
                  objectFit: "contain",
                  mt: 4,
                  boxShadow: 5,
                  borderRadius: 2,
                }}
                component="img"
                height="300"
                className="grid_img"
              />
            </Box>
          )}

          <div className="grid-item grid--2--cols">
            {/* thumbnail_image_url */}
            <TextField
              id="image_url"
              label="image_url"
              type="file"
              accept="image/png, image/jpeg, image/jpg, image/gif, image/svg+xml"
              InputLabelProps={{ shrink: true }}
              //value={values.thumbnail_image_url}
              onChange={imageChange}
              error={errors.image_url ? true : false}
              helperText={errors.image_url}
              inputRef={fileInputRef}
            />
            {/* Title */}
            {console.log("nmae ", values)}
            <TextField
              id="title"
              label="Name"
              value={values?.name}
              onChange={handleChange("name")}
              error={errors.name ? true : false}
              helperText={errors.name}
            />
          </div>
        </CardContent>
        <Box className="btn_end">
          <Button
            variant="contained"
            //color="warning"
            size="large"
            sx={{ height: 50, width: 100 }}
            disabled={loading || imageUploading}
            onClick={handleUpdate}
          >
            {/* {loading ? (
            <CircularProgress
              color="warning"
              value={progress}
              //text={`${progress}%`}
            />
          ) : (
            "Create"
          )} */}
            {loading ? <CircularProgress color="warning" /> : "Update"}
          </Button>
        </Box>
      </Card>
    </>
  );
};

export default UpdateMuscleType;
